Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.JointStyle = module.exports.default = {
	BEVEL: "bevel",
	MITER: "miter",
	ROUND: "round"
};